import { NextSeo } from 'next-seo';
import React from 'react';
import SKClubPageDetail from '../components/SKClubPageDetail';
import config from '../config';

function SKClubPage() {
  const title = `SK Club - ${config.siteName}`;
  const description = `Games and mobile apps by Shitty Kitties. Some chill & cozy, some chaotic, all uniquely Shitty.`;
  const url = 'https://www.shittykitties.art/sk-club';
  const ogImage = 'https://www.shittykitties.art/sk-club/og-sk-club.png';

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          type: 'website',
          url,
          title,
          description,
          images: [
            {
              url: ogImage,
              width: 1200,
              height: 630,
              alt: 'SK Club - Games & Mobile Apps by Shitty Kitties',
            },
          ],
        }}
        twitter={{ cardType: 'summary_large_image' }}
      />
      <SKClubPageDetail />
    </>
  );
}

export default SKClubPage;
